import React from 'react';
import { X } from '@phosphor-icons/react';
import './TermsOfService.css';

interface TermsOfServiceProps {
  onClose: () => void;
}

const TermsOfService: React.FC<TermsOfServiceProps> = ({ onClose }) => {
  const terms = [
    {
      number: '01',
      title: 'Reseller Disclaimer',
      content: (
        <>
          We are <strong>not the developers or owners</strong> of the software associated 
          with the licenses we sell. We act solely as a <strong>third-party reseller</strong>. All 
          responsibility for software functionality, stability, and compatibility 
          lies with the original developer.
        </>
      )
    },
    {
      number: '02',
      title: 'License Key Sales',
      content: (
        <>
          Upon successful payment, you will receive a license key for third-party software. 
          The delivery is handled automatically through our sales platform and payment 
          processors (e.g., PayPal). You are responsible for entering accurate contact 
          information (such as your email) to receive your product.
        </>
      )
    },
    {
      number: '03',
      title: 'No Refund Policy',
      content: (
        <>
          <strong>All sales are final.</strong> Refunds will not be provided under any 
          circumstance <strong>once the license key has been delivered</strong>, regardless 
          of usage or outcome. By purchasing, you acknowledge that the product is non-refundable.
        </>
      )
    },
    {
      number: '04',
      title: 'Software Use and Liability',
      content: (
        <>
          Your use of the licensed software is entirely at your own risk.
          <ul>
            <li>We are <strong>not responsible</strong> for how the software is used or any 
            consequences that result (e.g., game bans, data loss, or service violations).</li>
            <li>You are solely responsible for complying with the Terms of Service of any 
            third-party services or games the software interacts with.</li>
          </ul>
        </>
      )
    },
    {
      number: '05',
      title: 'Restrictions',
      content: (
        <>
          You agree not to:
          <ul>
            <li>Resell, redistribute, or share license keys you've purchased.</li>
            <li>Use the software in a way that violates applicable laws or third-party agreements.</li>
            <li>Hold us accountable for misuse or software-related issues.</li>
          </ul>
        </>
      )
    },
    {
      number: '06',
      title: 'Termination of Access',
      content: (
        <>
          We reserve the right to suspend or terminate future purchases if we 
          suspect abuse, fraud, or chargeback attempts.
        </>
      )
    },
    {
      number: '07',
      title: 'Limitation of Liability',
      content: (
        <>
          To the fullest extent permitted by law, we disclaim all liability for 
          losses, damages, or legal claims arising from your use of the software 
          or license keys purchased through our service.
        </>
      )
    },
    {
      number: '08',
      title: 'Disclaimer of Availability',
      content: (
        <>
          We do not guarantee that the software associated with any license key 
          will remain functional, supported, or accessible. If the original software 
          provider ceases operations, disables access, or is otherwise unavailable, 
          we are not liable for any resulting loss.
        </>
      )
    },
    {
      number: '09',
      title: 'Modifications to Terms',
      content: (
        <>
          We may revise these Terms at any time. Continued use of our services 
          after changes constitutes acceptance of the new Terms.
        </>
      )
    },
    {
      number: '10',
      title: 'Contact',
      content: (
        <>
          If you have questions, contact us on Discord: <strong>buyvolt.xyz</strong>
        </>
      )
    }
  ];

  return (
    <div className="tos-overlay" onClick={onClose}>
      <div className="tos-modal" onClick={(e) => e.stopPropagation()}>
        <div className="tos-header">
          <h2>Terms of Service</h2>
          <button className="tos-close" onClick={onClose}>
            <X weight="bold" />
          </button>
        </div>
        <div className="tos-content">
          {terms.map((term) => (
            <div key={term.number} className="tos-item">
              <div className="tos-item-header">
                <span className="tos-number">{term.number}.</span>
                <h3 className="tos-title">{term.title}</h3>
              </div>
              <div className="tos-text">{term.content}</div>
            </div>
          ))}
        </div>
        <div className="tos-footer">
          <p>By using buyvolt.xyz, you agree to these Terms of Service.</p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
